/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Usage_DescInputs */

const en_settings_usage_desc = /** @type {(inputs: Settings_Usage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your active features and quota.`)
};

const id_settings_usage_desc = /** @type {(inputs: Settings_Usage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitur aktif dan kuota kamu.`)
};

/**
* | output |
* | --- |
* | "Your active features and quota." |
*
* @param {Settings_Usage_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_usage_desc = /** @type {((inputs?: Settings_Usage_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Usage_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_usage_desc(inputs)
	return en_settings_usage_desc(inputs)
});